// import { useConfigModel } from "@/models"
import classNames from "classnames"
import type { FC } from "react"
import "./index.scss"

const scorePanelData = [
  {
    key: "S",
    value: "8-10",
    color: "rgba(255, 105, 235, 1)",
  },
  {
    key: "A",
    value: "6-8",
    color: "rgba(151, 141, 255, 1)",
  },
  {
    key: "B",
    value: "4-6",
    color: "rgba(74, 184, 255, 1)",
  },
  {
    key: "C",
    value: "2-4",
    color: "rgba(74, 255, 215, 1)",
  },
  {
    key: "D",
    value: "0-2",
    color: "rgba(114, 255, 74, 1)",
  },
]

const lightColors = [
  "rgba(255, 75, 75, 1)",
  "rgba(182, 3, 232, 1)",
  "rgba(17, 50, 255, 1)",
  "rgba(55, 202, 247, 1)",
  "rgba(60, 155, 0, 1)",
]

// const darkColors = [
//   "rgba(255, 105, 235, 1)",
//   "rgba(151, 141, 255, 1)",
//   "rgba(74, 184, 255, 1)",
//   "rgba(74, 255, 215, 1)",
//   "rgba(114, 255, 74, 1)",
// ]

const ScorePanel: FC = () => {
  // const { industryCategory } = useConfigModel()
  // const { isAllShow } = useControllerModel()
  // const colors = theme === "dark" ? darkColors : lightColors

  return (
    <div
      className={classNames(
        "score-panel flex flex-align-center",
        // !isAllShow && "hidden"
      )}
    >
      <span className="score-panel-title">客流评分</span>
      <ul className="score-panel-list flex flex-align-center">
        {scorePanelData.map((item, index) => (
          <li key={item.key} className="score-panel-item flex flex-column">
            <span
              className="score-panel-item-color"
              style={{ backgroundColor: lightColors[index] }}
            />
            <span>
              {item.key}({item.value})
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ScorePanel
